import { styled } from '@mui/system';
import { Box, Card, Chip, Badge } from '@mui/material';

export const Container = styled('div')`
  min-height: 100vh;
`;

export const SecondRowContainer = styled(Box)({
  maxWidth: '80vw',
  margin: '0 auto',
  '@media (max-width: 900px)': {
    maxWidth: '100%',
  },
});

export const StyledCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 12,
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
  },
}));

export const ImageContainer = styled(Box)({
  position: 'relative',
  paddingTop: '66.67%', // 3:2 aspect ratio
  overflow: 'hidden',
});

export const StatusBadge = styled(Box)(({ status }) => ({
  position: 'absolute',
  top: 12,
  left: 12,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 12px',
  borderRadius: 20,
  fontSize: '0.75rem',
  fontWeight: 600,
  color: '#fff',
  backgroundColor: 
    status === 'AC' ? '#4caf50' : 
    status === 'PP' ? '#ff9800' : 
    status === 'IN' ? '#9e9e9e' : 
    status === 'RE' ? '#f44336' : '#757575',
  backdropFilter: 'blur(4px)',
}));

export const VisibilityBadge = styled(Box)(({ visibility }) => ({
  position: 'absolute',
  top: 12,
  right: 12,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 12px',
  borderRadius: 20,
  fontSize: '0.75rem',
  fontWeight: 600,
  color: '#fff',
  backgroundColor: 
    visibility === 'PU' ? '#2196f3' : 
    visibility === 'PR' ? '#9c27b0' : 
    visibility === 'SE' ? '#607d8b' : '#757575',
  backdropFilter: 'blur(4px)',
}));

export const MemberCountBadge = styled(Badge)(({ theme }) => ({
  position: 'absolute',
  bottom: 12,
  right: 12,
  zIndex: 1,
  '& .MuiBadge-badge': {
    backgroundColor: theme?.palette?.primary?.main || '#1976d2',
    color: '#fff',
    fontWeight: 600,
    padding: '0 8px',
    height: 24,
    minWidth: 24,
    borderRadius: 12,
  },
}));

export const StatsRow = styled(Box)({
  display: 'flex',
  gap: 16,
  marginTop: 8,
});

export const StatItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  fontSize: '0.875rem',
  color: '#666',
});
